// providers/quickBooksOnline.ts
import * as Api from '@ViewModels';
import { provider, providerTags } from './helpers';

export const quickBooksOnlineConfig = provider(Api.IntegrationProvider.QuickBooksOnline, {
	displayName: 'QuickBooks Online',

	main: {
		writebacks: false,
	},

	tags: {
		coreTags: true,
		providerTags: providerTags(['Overdue', 'LastInvoice', 'ContactType', 'Active']),
	},

	showKeyFacts: false,
});
